import { useEffect, useState } from "react";
import { IMaskInput } from "react-imask";
import { updateClient } from "../../api/clients";
import { getCompanies } from "../../api/companies";
import "../../styles/pages/client-modal.css";

interface EditClientModalProps {
  client: any;
  onClose: () => void;
  onUpdated: () => void;
}

interface ClientForm {
  firstName: string;
  lastName: string;
  phone: string;
  whatsappPhone: string;
  email: string;
  companyName: string;   // ← ЭТО ВАЖНО
  tags: string;
  middleName: string;
  iin: string;
  idNumber: string;
  idIssuer: string;
  idIssueDate: string;
  regAddress: string;
}

export default function EditClientModal({ client, onClose, onUpdated }: EditClientModalProps) {
  const [form, setForm] = useState<ClientForm>({
    firstName: client.firstName || "",
    lastName: client.lastName || "",
    phone: client.phone || "",
    whatsappPhone: client.whatsappPhone || "",
    email: client.email || "",
    companyName: client.companyName || "",
    tags: client.tags?.join(", ") || "",
    middleName: client.middleName || "",
    iin: client.iin || "",
    idNumber: client.idNumber || "",
    idIssuer: client.idIssuer || "",
    idIssueDate: client.idIssueDate || "",
    regAddress: client.regAddress || "",
  });

  const [companies, setCompanies] = useState<any[]>([]);
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    const load = async () => {
      const res = await getCompanies();
      setCompanies(res); // ← FIX
    };
    load();
  }, []);

  const update = (key: keyof ClientForm, value: any) => {
    setForm({ ...form, [key]: value });
  };

  const validateEmail = (email: string) => {
    if (!email) return true;
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setEmailError(ok ? "" : "Некорректный email");
    return ok;
  };

  const submit = async () => {
    if (!validateEmail(form.email)) return;

    await updateClient(client.id, {
      ...form,
      tags: form.tags
        ? form.tags.split(",").map((t) => t.trim())
        : [],
      whatsappPhone: form.whatsappPhone.trim() ? form.whatsappPhone : null,
      middleName: form.middleName || null,
      iin: form.iin.replace(/D/g, "") || null,
      idNumber: form.idNumber.replace(/D/g, "") || null,
      idIssuer: form.idIssuer || null,
      idIssueDate: form.idIssueDate || null,
      regAddress: form.regAddress || null,
    });

    onUpdated();
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-window">
        <h2 className="modal-title">Редактировать клиента</h2>

        <div className="modal-form-grid">
          <input
            className="modal-input"
            placeholder="Имя"
            value={form.firstName}
            onChange={(e) => update("firstName", e.target.value)}
          />

          <input
            className="modal-input"
            placeholder="Фамилия"
            value={form.lastName}
            onChange={(e) => update("lastName", e.target.value)}
          />

          <IMaskInput
            mask="+7 (000) 000-00-00"
            className="modal-input"
            placeholder="Телефон"
            value={form.phone}
            onAccept={(value) => update("phone", value)}
          />

          <IMaskInput
            mask="+7 (000) 000-00-00"
            className="modal-input"
            placeholder="WhatsApp (если отличается от телефона)"
            title="Уведомления уходят на этот номер. Пусто — на основной телефон. Войти в кабинет можно по любому из двух номеров."
            value={form.whatsappPhone}
            onAccept={(value) => update("whatsappPhone", value)}
          />

          <div>
            <input
              className="modal-input"
              placeholder="Email"
              value={form.email}
              onChange={(e) => {
                update("email", e.target.value);
                validateEmail(e.target.value);
              }}
            />
            {emailError && <div className="input-error">{emailError}</div>}
          </div>

          <select
            className="modal-input"
            value={form.companyName}
            onChange={(e) => update("companyName", e.target.value)}
          >
            <option value="">Компания не выбрана</option>
            {companies.map((c) => (
              <option key={c.id} value={c.name}>
                {c.name}
              </option>
            ))}
          </select>

          <input
            className="modal-input"
            placeholder="Теги (через запятую)"
            value={form.tags}
            onChange={(e) => update("tags", e.target.value)}
          />
        </div>

        <div style={{ fontSize: 12, fontWeight: 600, color: "#9ca3af", margin: "16px 0 8px" }}>
          Данные для договора (клиент может заполнить сам в личном кабинете)
        </div>
        <div className="modal-form-grid">
          <input className="modal-input" placeholder="Отчество" value={form.middleName} onChange={(e) => update("middleName", e.target.value)} />
          <input className="modal-input" placeholder="ИИН (12 цифр)" maxLength={12} value={form.iin} onChange={(e) => update("iin", e.target.value.replace(/\D/g, ""))} />
          <input className="modal-input" placeholder="№ удостоверения личности" maxLength={9} value={form.idNumber} onChange={(e) => update("idNumber", e.target.value.replace(/\D/g, ""))} />
          <input className="modal-input" placeholder="Кем выдано (МВД РК)" value={form.idIssuer} onChange={(e) => update("idIssuer", e.target.value)} />
          <input className="modal-input" type="date" title="Дата выдачи удостоверения" value={form.idIssueDate} onChange={(e) => update("idIssueDate", e.target.value)} />
          <input className="modal-input" placeholder="Адрес регистрации" value={form.regAddress} onChange={(e) => update("regAddress", e.target.value)} />
        </div>

        <div className="modal-actions">
          <button className="btn primary" onClick={submit}>
            Сохранить
          </button>
          <button className="btn" onClick={onClose}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}
